import React, { Component } from 'react';
import QueryString from 'query-string';

import './profile.css'

//Navigation
import Sidebar from '../../components/Navigation/Sidebar';
import Topbar from '../../components/Navigation/Topbar';
import Footer from '../../components/Footer';

import { withOktaAuth } from '@okta/okta-react';

import ColdStorageProfileCard from '../../components/ColdStorage/list-view/ColdStorageProfileCard';

class ColdStorage extends Component {
  constructor(props) {
    super(props);

    // redirect to 404 if user doesn't have campaign role
    const claims = this.props.authState.accessToken.claims;
    if(claims){
      const claimKeys = Object.keys(claims);
      const roleKey = claimKeys?.find(key => /roles_/.test(key));
      const roles = claims[roleKey];
      const coldStorageRole = roles?.find(value => /cold_storage/.test(value));
      const M2MRole = roles?.find(value => /ksm_m2m/.test(value));
      if(!coldStorageRole || !M2MRole){
        window.location.href = "/404";
      }
    }
  }

  render() {
    let params = QueryString.parse(this.props.location.search)

    var size = params.size;
    if (size === undefined) size = 10;
  

    var page = params.page;
    if (page === undefined) page = 0;

    var search = params.search;
    
    // default to render ProfileCard
    var viewToRender = <ColdStorageProfileCard size={size} page={page} search={search}/>;

    // render EisSingle if `eid` param is set
    if ((params.eid !== undefined) && (params.eid !== "")){
      // viewToRender = <EisSingle eid={params.eid}/>
    }

    return (
      <div>
        {/* <!-- Page Wrapper --> */}
        <div id="wrapper">
          <Sidebar active="Storage"/>

          {/* <!-- Content Wrapper --> */}
          <div id="content-wrapper" className="d-flex flex-column">

            {/* <!-- Main Content --> */}
            <div id="content">
              <Topbar icon="bi-snow3" title="eSIMs Cold Storage"/>

              {/* <!-- Begin Page Content --> */}
              <div className="container-fluid">
                {viewToRender}
              </div>
              {/* <!-- /.container-fluid --> */}

            </div>
            {/* <!-- End of Main Content --> */}

            <Footer />
          </div>
          {/* <!-- End of Content Wrapper --> */}

        </div>
        {/* <!-- End of Page Wrapper --> */}
      </div>
    )
  }
}

export default withOktaAuth(ColdStorage);